// import styles from './navBar.module.css'
import styles from './navbar.module.css';
import React from 'react'



let NabLinks=()=> <ul  className={styles.nav_links}>
<li>
  <a href="#projects" class="link"><i class="fas fa-code"></i> Projects</a>
</li>
<li>
  <a href="#skills" class="link"><i class="fas fa-tools"></i> Skills</a>
</li>
<li>
  <a href="#about" class="link"><i class="fas fa-user-graduate"></i> About</a>
</li>
<li>
  <a href="https://drive.google.com/file/d/1sLKk18eRX87qDkzlgWH2vIrP5GllcLua/view?usp=sharing" class="link" target="_blank" rel="noreferrer"><i class="fas fa-file"></i> Resume</a>
</li>
<li>
  <a href="#contact" class="link"><i class="fas fa-envelope"></i> Contact</a>
</li>
</ul>

const NavBar=()=>{ 
    return <div className={styles.main}>
        <div className={styles.logo}>
        <img src="logo.png" alt="logo" />
         </div>
         <div className={styles.navbar_large}><NabLinks/></div>
         {/* <div className={styles.navbar_small}> <NabLinks/></div> */}
    </div>
}


const NavbarP = () => {
   const [showNavList, setShowNavList] = React.useState(false);

  const toggleNavList = (id) => {
    var element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
    }
    setShowNavList(!showNavList);
  };
  return (
    <>
      <nav className={styles.center+" "+styles.nav}>
        <ul
          style={{ display: showNavList ? "flex" : null }}
          className={styles.nav__list}
        >
          <li className={styles["nav__list-item"]}>
            <a
              href="#home"
              onClick={() => toggleNavList("#home")}
              className={styles.link+" "+styles["link--nav"]}
            >
              Home
            </a>
          </li>
          <li className={styles["nav__list-item"]}>
            <a
              href="#home"
              onClick={() => toggleNavList("#home")}
              className={styles.link+" "+styles["link--nav"]}
            >
              Home
            </a>
          </li>
          <li className={styles["nav__list-item"]}>
            <a
              href="#home"
              onClick={() => toggleNavList("#home")}
              className={styles.link+" "+styles["link--nav"]}
            >
              Home
            </a>
          </li>
          <li className={styles["nav__list-item"]}>
            <a
              href="#home"
              onClick={() => toggleNavList("#home")}
              className={styles.link+" "+styles["link--nav"]}
            >
              Home
            </a>
          </li>
          <li className={styles["nav__list-item"]}>
            <a
              href="#home"
              onClick={() => toggleNavList("#home")}
              className={styles.link+" "+styles["link--nav"]}
            >
              Home
            </a>
          </li>
        </ul> 
        <button
          type="button"
          onClick={toggleNavList}
          className="btn btn--icon nav__hamburger"
          aria-label="toggle navigation"
        >
          {showNavList ? "Close" : "Open"}
        </button>
      </nav>
    </>
  );
};

export default NavBar;
